import { useTranslation } from "react-i18next";
import type { AnalyticsLiveKpis, AnalyticsSnapshotResponse } from "@/features/admin/adminAnalytics.types";
import { KPICard } from "@/features/admin/components/analytics/KPICard";
import { GenericAnalyticsTab } from "@/features/admin/components/analytics/GenericAnalyticsTab";

export function PlatformHealthAnalyticsTab({
  liveKPIs,
  loading,
  snapshot,
}: {
  liveKPIs: AnalyticsLiveKpis | null;
  loading?: boolean;
  snapshot: AnalyticsSnapshotResponse | null;
}) {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <div className="grid gap-4 md:grid-cols-3">
        <KPICard metric={{ currentState: true, key: "budget", label: t("adminWorkspace.analytics.health.budget"), unit: "percent", value: liveKPIs?.aiBudgetStatus.percent ?? null }} />
        <KPICard metric={{ currentState: true, key: "imports", label: t("adminWorkspace.analytics.health.activeImports"), unit: "count", value: liveKPIs?.activeJobCounts.imports ?? null }} />
        <KPICard metric={{ currentState: true, key: "flagged", label: t("adminWorkspace.analytics.health.flaggedUsers"), unit: "count", value: liveKPIs?.flaggedUsersCount ?? null }} />
      </div>
      <GenericAnalyticsTab
        loading={loading}
        panels={[
          { chart: "line", metricKey: "app_log_errors", series: ["total"], title: t("adminWorkspace.analytics.health.errors") },
          { chart: "line", metricKey: "app_log_criticals", series: ["total"], title: t("adminWorkspace.analytics.health.criticals") },
          { chart: "bar", metricKey: "import_jobs_completed", series: ["total"], title: t("adminWorkspace.analytics.health.importsCompleted") },
          { chart: "bar", metricKey: "import_jobs_failed", series: ["total"], title: t("adminWorkspace.analytics.health.importsFailed") },
        ]}
        snapshot={snapshot}
      />
    </div>
  );
}
